// Cantidad con su sustantivo en singular o plural ("1 proceso", "0 procesos"): una sola
// fuente para el copy de conteos de todas las pantallas (UX-COPY-01).

export function plural(n: number, one: string, many: string): string {
  return `${n} ${n === 1 ? one : many}`;
}
